module.exports = __webpack_public_path__ + "img/logout.74d2af37.png";